import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { documentsApi, type Document } from '../../api/documents';

export function RepositoryBrowserPage() {
  const [documents, setDocuments] = useState<Document[]>([]);
  const [name, setName] = useState('');
  const [category, setCategory] = useState('invoice');
  const [error, setError] = useState('');

  const load = () => {
    void documentsApi.listDocuments(100).then((r) => setDocuments(r.documents)).catch((e) => setError(String(e)));
  };

  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!name.trim()) return;
    try {
      await documentsApi.createDocument({ name, category, content: 'Document content' });
      setName('');
      load();
    } catch (e) {
      setError(String(e));
    }
  };

  return (
    <div className="mx-auto max-w-5xl p-6">
      <Link to="/documents" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Document Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Repository Browser</h1>
      <div className="mt-6 flex flex-wrap gap-3">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Document name"
          className="rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" />
        <select value={category} onChange={(e) => setCategory(e.target.value)}
          className="rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900">
          <option value="invoice">Invoice</option>
          <option value="contract">Contract</option>
          <option value="gst">GST</option>
          <option value="purchase_order">Purchase Order</option>
          <option value="pdf">PDF</option>
        </select>
        <button onClick={() => void create()}
          className="rounded bg-slate-900 px-4 py-2 text-white dark:bg-slate-100 dark:text-slate-900">
          Upload Document
        </button>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-left dark:border-slate-700">
              <th className="p-2">Name</th>
              <th className="p-2">Category</th>
              <th className="p-2">Version</th>
              <th className="p-2">OCR</th>
              <th className="p-2">Signed</th>
              <th className="p-2">Updated</th>
            </tr>
          </thead>
          <tbody>
            {documents.map((d) => (
              <tr key={d.id} className="border-b dark:border-slate-800">
                <td className="p-2 font-medium">{d.name}</td>
                <td className="p-2 capitalize">{d.category.replace('_', ' ')}</td>
                <td className="p-2">v{d.current_version}</td>
                <td className="p-2">{d.ocr_processed ? '✓' : '—'}</td>
                <td className="p-2">{d.signed ? '✓' : '—'}</td>
                <td className="p-2 text-slate-500">{new Date(d.updated_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
